class CollectionSidebarNavigation extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Connected Callback Hook
   *
   * Called when the element is added to the DOM
   */
  connectedCallback() {
    // Click event listener
    this.addEventListener("click", this.componentEventHandler.bind(this));

    // Set active link for navigation
    this.setActiveLink();
  }

  /**
   * Disconnected Callback
   * Is called when the element is removed from the DOM
   */
  disconnectedCallback() {
    this.removeEventListener("click", this.componentEventHandler(), true);
  }

  /**
   * Handle component event
   *
   * @param {Event} event
   */
  componentEventHandler(event) {
    // Elements
    const subnavDropItem = event.target.closest(".subnavigation-dropdown-item");
    const subnavDropTrigger = event.target.closest(
      ".collection-subnavigation-dropdown-trigger"
    );

    // Handle trigger and check if subnavDropItem is null
    if (subnavDropTrigger && !subnavDropItem) {
      this.subnavDropdownController(subnavDropTrigger);
      return;
    }

    // Handle subnavDropItem
    if (subnavDropItem) {
      this.subnavDropItemController(subnavDropItem);
      return;
    }
  }

  /**
   * Subnav Dropdown Controller
   *
   * Toggle the visibility of a dropdown trigger element
   * @param {HTMLElement} element Dropdown trigger
   */
  subnavDropdownController(element) {
    const isOpen = element.dataset.showCollectionSubnavigation === "true";
    element.dataset.showCollectionSubnavigation = isOpen ? false : true;
  }

  /**
   * Subnav Dropdown Item Controller
   *
   * @param {HTMLElement} element Dropdown item
   */
  subnavDropItemController(element) {
    element.classList.toggle("active-link");
  }

  /**
   * Set active link
   *
   * Set the active link in the navigation based on the current URL
   */
  setActiveLink() {
    // Build URL element and getting pathname
    const urlObject = new URL(window.location.href);
    const { pathname } = urlObject;

    // Get link item based on the pathname
    const linkItem = this.querySelector(`a[href="${pathname}"]`);
    linkItem.classList.add("active-link");

    // Get link's dropdown parent element
    const dropdownParent = linkItem.parentElement.closest(
      ".collection-subnavigation-dropdown-trigger"
    );
    if (!dropdownParent) return;

    // Set active element
    this.subnavDropdownController(dropdownParent);
  }
}

customElements.define(
  "collection-sidebar-navigation",
  CollectionSidebarNavigation
);
